export function wsForm(callbackFunction) {
    if (typeof jQuery !== 'undefined') {
        jQuery(document).on('wsf-rendered', (e, form, form_id, instance_id) => {
            const wsForm = document.querySelector(`.wsf-form[data-id="${form_id}"]`);

            if (wsForm) {
                const wsfLang = document.createElement('input');
                wsfLang.type = 'hidden';
                wsfLang.name = 'lang';
                wsfLang.value = wsForm.dataset.pawsLanguage;
                wsForm.appendChild(wsfLang);

                const wsfId = document.createElement('input');
                wsfId.type = 'hidden';
                wsfId.name = 'wsfid';
                wsfId.value = wsForm.getAttribute('data-id');
                wsForm.appendChild(wsfId);
            }
        });
    }
}